// frontend/shared-ui/src/forms/fields/BooleanField.jsx
import React from "react";

export default function BooleanField({ field, value, onChange }) {
  const inputId = `field-${field.key}`;
  return (
    <div className="fh-form-field">
      <label htmlFor={inputId} className="fh-form-field__label">
        {field.label}
      </label>
      <label className="fh-toggle">
        <input
          id={inputId}
          type="checkbox"
          checked={!!value}
          onChange={(e) => onChange(e.target.checked)}
          disabled={field.disabled}
        />
        <span className="fh-toggle__track">
          <span className="fh-toggle__thumb" />
        </span>
        <span className="fh-toggle__label">
          {value ? field.onLabel || "Yes" : field.offLabel || "No"}
        </span>
      </label>
      {field.hint && <div className="fh-form-field__hint">{field.hint}</div>}
    </div>
  );
}
